var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWomenSmallPlain = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    strokeMiterlimit: 10,
    viewBox: "0 0 188 188",
    xmlns: "http://www.w3.org/2000/svg",
    clipRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Velasca Women") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134.404 140.361a6.919 6.919 0 0110.403-6.062 6.92 6.92 0 11-10.403 6.062zM109.629 36.336c-3.194 26.585-6.973 53.144-12.215 79.383-1.144 5.694-2.315 11.416-3.699 17.084-.559 2.315-1.198 4.684-2.342 6.786-.08.133-.16.24-.24.346a2.353 2.353 0 01-.452-.213c-3.752-2.288-5.562-6.919-7.105-10.804-2.315-5.881-4.125-11.922-5.642-18.069-3.912-15.834-6.333-31.908-6.919-48.22-.053-1.81-11.363-.08-11.257 3.006.56 16.313 3.008 32.387 6.92 48.221 1.676 6.839 3.699 13.652 6.493 20.145 1.73 4.045 4.151 8.542 8.436 10.298 5.402 2.209 13.598.48 17.99-3.193 4.31-3.592 5.109-9.873 6.28-15.035 3.086-13.839 5.615-27.81 7.877-41.807 2.741-16.925 5.056-33.904 7.105-50.935.16-1.277-10.831-.346-11.23 3.007z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWomenSmallPlain);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "women-small-plain.e56301bbe9e95b951ffa35b17a729f39.svg";